var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[(_vm.isLoggedIn)?_c('Menu'):_vm._e(),(_vm.isLoading)?_c('div',[_c('div',[_vm._v("Loading...")])]):_vm._e(),_c('router-view',{staticClass:"main-container"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }